import { render, staticRenderFns } from "./ProductCreate.vue?vue&type=template&id=4c54543c&scoped=true&"
import script from "./ProductCreate.vue?vue&type=script&lang=ts&"
export * from "./ProductCreate.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCreate.vue?vue&type=style&index=0&id=4c54543c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c54543c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFadeTransition,VRow,VSpacer})
